var render = function () {
  var _vm$activeStory$butto, _vm$activeStory$butto2, _vm$activeStory$image, _vm$activeStory$image2, _vm$activeStory$image3;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.active ? _c('div', {
    staticClass: "mp-stories",
    on: {
      "click": function ($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.$emit('close');
      }
    }
  }, [_c('div', {
    staticClass: "mp-stories__modal"
  }, [_c('div', {
    staticClass: "mp-stories__wrapper"
  }, [_vm.error || !_vm.stories.length ? [_vm._m(0)] : _c('div', {
    staticClass: "mp-stories__story"
  }, [_c('div', {
    ref: "story",
    staticClass: "story__overlay story__overlay_desktop",
    on: {
      "mousedown": _vm.handleTouchStart,
      "mouseup": _vm.handleTouchEnd
    }
  }), _vm._v(" "), _c('div', {
    ref: "story",
    staticClass: "story__overlay story__overlay_mobile",
    on: {
      "touchstart": _vm.handleTouchStart,
      "touchend": _vm.handleTouchEnd
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "story__time"
  }, _vm._l(_vm.stories.length, function (_, i) {
    return _c('div', {
      key: i,
      staticClass: "time__item"
    }, [_c('div', {
      staticClass: "time__fill",
      class: {
        time__fill_active: i === _vm.activeStoryIndex,
        time__fill_paused: i === _vm.activeStoryIndex && _vm.isPaused,
        time__fill_completed: i < _vm.activeStoryIndex
      },
      style: i === _vm.activeStoryIndex ? _vm.timeFillStyle : undefined
    })]);
  }), 0), _vm._v(" "), (_vm$activeStory$butto = _vm.activeStory.button) !== null && _vm$activeStory$butto !== void 0 && _vm$activeStory$butto.text && (_vm$activeStory$butto2 = _vm.activeStory.button) !== null && _vm$activeStory$butto2 !== void 0 && _vm$activeStory$butto2.path ? _c('div', {
    staticClass: "story__promo-button-wrapper"
  }, [_c('GGLink', {
    staticClass: "story__promo-button",
    attrs: {
      "to": _vm.activeStory.button.path
    }
  }, [_vm._v("\n            " + _vm._s(_vm.activeStory.button.text) + "\n          ")])], 1) : _vm._e(), _vm._v(" "), _vm.isVideo ? _c('video', {
    ref: "video",
    staticClass: "story__video",
    attrs: {
      "src": (_vm$activeStory$image = _vm.activeStory.image) === null || _vm$activeStory$image === void 0 ? void 0 : _vm$activeStory$image.x1,
      "autoplay": "",
      "loop": "",
      "muted": "",
      "playsinline": ""
    },
    domProps: {
      "muted": true
    },
    on: {
      "loadedmetadata": _vm.onVideoLoaded
    }
  }) : _c('img', {
    staticClass: "story__image",
    attrs: {
      "src": (_vm$activeStory$image2 = _vm.activeStory.image) === null || _vm$activeStory$image2 === void 0 ? void 0 : _vm$activeStory$image2.x1,
      "srcset": ((_vm$activeStory$image3 = _vm.activeStory.image) === null || _vm$activeStory$image3 === void 0 ? void 0 : _vm$activeStory$image3.x2) && ((_vm.activeStory.image.x2) + " 2x")
    }
  })])], 2)]), _vm._v(" "), _c('button', {
    staticClass: "mp-stories__close",
    on: {
      "click": function ($event) {
        return _vm.$emit('close');
      }
    }
  }, [_vm._v("Закрыть")])]) : _vm._e();
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('p', [_vm._v("\n          Не удалось загрузить\n          "), _c('br'), _vm._v("\n          контент\n        ")]);
}]

export { render, staticRenderFns }